<template>
  <div class="simple-card bg-white overflow-hidden h-full" :class="count % 2 === 0 ? 'beautiful-radius' : 'beautiful-radius-inverted'">
    <div class="md:h-72 h-64 group overflow-hidden cursor-pointer">
      <div class="bg-no-repeat bg-cover w-full h-full group-hover:scale-110 scale-1 transition transform" v-if="content.img" :style="`backgroundImage: url(${content.img.filename})`"></div>
    </div>
    <div class="p-8">
      <h4 class="font-medium text-gray-700 leading-tight text-2xl" v-html="content.title"></h4>
      <p class="font-medium text-gray-500 leading-tight py-4 text-base" v-html="content.text"></p>
      <div class="text-center">
        <a :href="content.link.url" class="inline-block mt-2 transition duration-300 hover:bg-primary-dark bg-primary text-white px-6 py-2 rounded-xl text-base" target="_blank" v-if="content.link" v-html="content.link_text"></a>
      </div>
    </div>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  props: {
    content: {
      type: Object,
      default: null,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
.simple-card {
  box-shadow: 0 5px 10px rgba(154, 160, 185, 0.05),
    0 15px 40px rgba(166, 173, 201, 0.2);
}
</style>